<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="参与人数" prop="joinNum">
              <el-input maxlength="9" type="text" placeholder="参与人数" v-model="form.joinNum">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否有志愿者" prop="ifVolunteer">
              <el-radio-group v-model="form.ifVolunteer">
                <el-radio v-for="item in optList" :key="item.dictKey" :label="item.dictKey">{{
                  item.dictValue
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="志愿者" prop="volunteerName">
              <el-input
                maxlength="500"
                type="textarea"
                :rows="2"
                placeholder="请输入志愿者"
                v-model="form.volunteerName"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="活动总结" prop="summarize">
              <VueEditor
                id="editor"
                v-model="form.summarize"
                useCustomImageHandler
                @image-added="handelRichTextImageAdded"
              ></VueEditor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        提交
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import { activeSummarize } from '@/api/nursingHome/activemanage';
import { putFile } from '@/api/crmedical/contract/add';
import { getDictionary } from '@/api/common.js';

export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      form: {
        id: '',
        summarize: '',
        joinNum: 0,
        ifVolunteer: '2',
        volunteerName: '',
      },
      formRules: {
        summarize: [{ required: true, message: '活动总结不能为空', trigger: 'change' }],
        joinNum: [
          { required: true, message: '参与人数不能为空', trigger: 'blur' },
          {
            pattern: /^[1-9]\d*$|^0$/,
            message: '参与人数必须为大于或等于0的整数',
            trigger: 'blur',
          },
        ],
        ifVolunteer: [{ required: true, message: '是否有志愿者不能为空', trigger: 'blur' }],
      },
      optList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {
    'form.ifVolunteer': {
      immediate: true,
      handler(val) {
        if (val == 2) {
          this.formRules.volunteerName = [
            { required: true, message: '志愿者不能为空', trigger: 'blur' },
          ];
          this.formRules = Object.assign({}, this.formRules);
        } else {
          this.formRules.volunteerName = [];
          const formRef = this.$refs.formRef
          formRef && formRef.clearValidate('volunteerName');
        }
      },
    },
  },
  methods: {
    handelRichTextImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append('file', file);
      // 通过上传接口返回url，将url放入富文本编辑器中
      putFile(formData)
        .then((res) => {
          let url = res.data.link;
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async initData() {
      console.log('this.row-----', this.row);
      this.form.id = this.row.id;
      this.form.summarize = this.row.summarize;
      this.form.joinNum = this.row.joinNum || 0;
      this.form.ifVolunteer = this.row.ifVolunteer || '2';
      this.form.volunteerName = this.row.volunteerName;
      getDictionary('yes_no').then((res) => {
        this.optList = res.data;
      });
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.form.joinNum = parseInt(this.form.joinNum);
          activeSummarize(this.form).then((res) => {
            this.$message.success('提交成功');
            this.$emit('success');
          });
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
